import React from "react";
import { MenuButton as ChakraMenuButton } from "@chakra-ui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Button } from "./button";
import { IconButton } from "./icon-button";
export function FilterMenuButton({ icon, children, ...props }) {
    if (icon) {
        return (React.createElement(ChakraMenuButton, { as: IconButton, "aria-label": children, icon: icon, ...props }));
    }
    return (React.createElement(ChakraMenuButton, { as: Button, directionIcon: ChevronDownIcon, ...props }, children));
}
